import React from 'react'
import { Link } from 'react-router-dom'

import BrandLogo from '@components/BrandLogo/BrandLogo'

import LayoutCentered from '@components/LayoutCentered/LayoutCentered'

import './Welcome.scss'

@LayoutCentered
class Welcome extends React.Component {
	render() {
		return (
			<main className="Welcome">
				<header className="Welcome-header">
					<BrandLogo />
					<h1>Welcome</h1>
				</header>	
				<div className="Welcome-content">
					<Link className="Welcome-button" to='/register'>registration</Link>	
					<Link className="Welcome-button" to='/login'>login</Link>	
				</div>
			</main>
		)
	}
}


export default Welcome;


// WEBPACK FOOTER //
// ./src/scenes/Welcome/Welcome.jsx